module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAMAAAAs2N9uAAAAYFBMVEUAAACZmZmZmZmYmJiZmZmZmZmZmZmZmZmZmZmYmJidnZ2ZmZmZmZmbm5uXl5eZmZmZmZmZmZmZmZmampqZmZmYmJiZmZmZmZmZmZmZmZmYmJiZmZmampqampqampqZmZkk/bJaAAAAH3RSTlMAWk0d7+Kpom0nGubMFA34sI1fPTcv2tfDu5WUfnREe0qougAAAHdJREFUGNNdzkkSgjAARNEmRJNIAEGch3//WxoKLUj+8lUvWkuh56S8JjranNKGoaBK9plJRxDnjI7I0OxS9zoN/HuMGIWX26dsI0XgMumfQcLUaG3oE33a7aPbdVkdVrKupI6qpIlQkkeaT7P5bGd6eHz1a8RJXzODB4vR5BESAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/agree_with.png
// module id = sTjA
// module chunks = 104